<div class="legal-document-page">
  <app-header
    [title]="'Mentions légales'"
    [showBackButton]="true"
    [showMenu]="false"
    [usePageBackground]="true"
  ></app-header>

  <div class="page-content">
    <div class="legal-card" [innerHTML]="legalText"></div>
  </div>
</div>
